import { initLoginForm } from "../../pages/loginOrSignup/login";

export default function setupOffcanvasLoginUI() {
  const loginToggle = document.getElementById("login-toggle");
  const accountToggle = document.getElementById("account-toggle");
  const accountDropdown = document.querySelector(".account-dropdown");
  const closeLogin = document.querySelector(".close-login");
  const loginOffcanvas = document.querySelector(".login-offcanvas");
  const overlay = document.querySelector(".overlay");

  function showLoginOffcanvas() {
    loginOffcanvas.classList.remove("hide");
    loginOffcanvas.classList.add("show");
    overlay.classList.remove("hide");
    overlay.classList.add("show");
    document.body.style.overflow = "hidden"; // Prevent scrolling
  }

  function hideLoginOffcanvas() {
    loginOffcanvas.classList.remove("show");
    loginOffcanvas.classList.add("hide");
    overlay.classList.remove("show");
    overlay.classList.add("hide");
    document.body.style.overflow = ""; // Restore scrolling
  }

  // Event Listeners for account dropdown
  if (accountToggle && accountDropdown) {
    let isHovering = false;

    // Handle account dropdown toggle
    accountToggle.addEventListener("click", (e) => {
      e.stopPropagation();
      accountDropdown.classList.toggle("show");
      accountDropdown.classList.toggle("hide");
    });

    // Handle hover states
    [accountToggle, accountDropdown].forEach((element) => {
      element.addEventListener("mouseenter", () => {
        isHovering = true;
      });

      element.addEventListener("mouseleave", () => {
        isHovering = false;
        setTimeout(() => {
          if (!isHovering) {
            accountDropdown.classList.remove("show");
            accountDropdown.classList.add("hide");
          }
        }, 100); // Small delay to check if user moved to other element
      });
    });

    // Close dropdown when clicking outside
    document.addEventListener("click", (e) => {
      if (
        !accountToggle.contains(e.target) &&
        !accountDropdown.contains(e.target)
      ) {
        accountDropdown.classList.remove("show");
        accountDropdown.classList.add("hide");
      }
    });
  }

  // Setup login offcanvas
  if (loginToggle) {
    loginToggle.addEventListener("click", showLoginOffcanvas);
    closeLogin?.addEventListener("click", hideLoginOffcanvas);
    overlay?.addEventListener("click", hideLoginOffcanvas);

    // Initialize login form handler
    const offcanvasLoginForm = document.getElementById("offcanvas-login-form");
    if (offcanvasLoginForm) {
      initLoginForm();
    }
  }
}
